import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    PHONEFORM_TYPE: {
        id: 'PhoneForm.typeRequired',
        defaultMessage: 'Type is a required field',
    },
    PHONEFORM_COUNTRYCODE: {
        id: 'PhoneForm.countryCodeRequied',
        defaultMessage: 'Country code is a required field',
    },
    PHONEFORM_COUNTRYCODE_NUMERIC: {
        id: 'PhoneForm.countryCodeNumber',
        defaultMessage: 'Country code must be a number',
    },
    PHONEFORM_AREACODE: {
        id: 'PhoneForm.areaCodeRequired',
        defaultMessage: 'Area code is a required field',
    },
    PHONEFORM_AREACODE_LENGTH: {
        id: 'PhoneForm.areaCodeLength',
        defaultMessage: 'Area code has a max of 5 digits',
    },
    PHONEFORM_NUMBER: {
        id: 'PhoneForm.numberRequired',
        defaultMessage: 'Number is a required field',
    },
    PHONEFORM_NUMBER_MIN_LENGTH: {
        id: 'PhoneForm.numberMin',
        defaultMessage: 'Number must be a minimum of 4 digits',
    },
    PHONEFORM_NUMBER_MAX_LENGTH: {
        id: 'PhoneForm.numberMax',
        defaultMessage: 'Number must be a maximum of 15 digits',
    },
    PHONEFORM_EXTENSION_MAX_LENGTH: {
        id: 'PhoneForm.extensionMax',
        defaultMessage: 'Extension must have a maximum of 10 digits',
    },
});

export default enumMessages;
